export default "__VITE_ASSET__B$puIJ8b__"